import Icon from '../components/Icon.vue'

Icon.register({
  'location-arrow': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M444.5 3.5c38.4-16 80 25.6 64 64l-191.9 415.8c-22.4 48-92.8 32-92.8-19.2v-175.9h-175.9c-51.2 0-67.2-70.4-19.2-92.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/location-arrow.js
// module id = 1529
// module chunks = 0